import { AutoMap } from "@automapper/classes";

export class MaterielCompresseurDTO {
    @AutoMap()
    referenceHuile!: string;
}